import type { SiteFooterLocale } from './siteLocales';

export const SCROLL_TO_TOP_LABELS: Record<SiteFooterLocale, string> = {
  "zh-CN": "回到顶部",
  "zh-TW": "回到頂部",
  "en-US": "Scroll to top",
  "th-TH": "กลับขึ้นด้านบน",
  "id-ID": "Kembali ke atas",
  "ko-KR": "맨 위로",
  "ja-JP": "ページトップへ",
  "vi-VN": "Lên đầu trang",
  "ms-MY": "Kembali ke atas"
} as const;
